import postalCodeRegexMap from './postal-code-regex.json'
import {PhoneNumberUtil} from 'google-libphonenumber'
import countryRegionJSON from './country-region.json'

// Initialize instance
const phoneUtil = PhoneNumberUtil.getInstance()

export const validatePostalCode = (countryCode, postalCode) => {
  if (!countryCode || !postalCode) return false

  const entry = postalCodeRegexMap[countryCode.toUpperCase()]
  if (!entry) {
    return false
  }
  const regexPattern = entry.regex

  // Pattern is sourced from the bundled static postal-code-regex.json, not user input.
  // nosemgrep: eslint.detect-non-literal-regexp
  const regex = new RegExp(regexPattern, 'i')

  return regex.test(postalCode.trim())
}

export const validatePhoneNumber = (countryCode, phoneNumber) => {
  if (!countryCode || !phoneNumber) return false

  try {
    const parsedNumber = phoneUtil.parse(phoneNumber, countryCode.toUpperCase())
    return phoneUtil.isValidNumberForRegion(
      parsedNumber,
      countryCode.toUpperCase(),
    )
  } catch (error) {
    // Parsing failed (invalid number format etc.)
    return false
  }
}

export const fetchSelectedCountryRegionList = countryCode => {
  let selectedCountryJSON = countryRegionJSON.find(
    item => item.code === (countryCode?.value || countryCode),
  )

  return (selectedCountryJSON?.regions || [])
    .map(({name, code}) => ({
      name,
      value: code,
    }))
    .sort((a, b) => (a.name > b.name ? 1 : -1))
}
